import { db } from '../index';
import { municipioUfMapper } from '../schemas/MunicipioUfSchema';

class MunicipioUfRepository {
  async findAll() {
    return await db.municipios.toArray();
  }

  async bulkUpsert(apiData) {
    const entities = municipioUfMapper.toEntity(apiData);

    return await db.transaction('rw', db.municipios, async () => {
      await db.municipios.clear();
      return await db.municipios.bulkAdd(entities);
    });
  }

  async getLastUpdate() {
    const last = await db.municipios.orderBy('updatedAt').last();
    return last ? last.updatedAt : null;
  }

  async clear() {
    return await db.municipios.clear();
  }

  async needsRefresh(maxAge = 30 * 24 * 60 * 60 * 1000) {
    const lastUpdate = await this.getLastUpdate();
    if (!lastUpdate) return true;

    return (Date.now() - lastUpdate) > maxAge;
  }
}

export const municipioUfRepository = new MunicipioUfRepository();
